// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__34kqU","selected":"Chip_selected__1sr1M"};